<template>

  <v-dialog v-model="displayed"
            :persistent="true"
            max-width="480px">

    <v-card>
      <v-card-text>

        <p class="title">{{ title || 'Please wait' }}</p>
        <p class="text">{{ text || '' }}</p>

        <div class="loader">
          <div class="bar"></div>
        </div>

      </v-card-text>
    </v-card>

  </v-dialog>

</template>

<script>

export default {
  name: 'LoadingPopup',
  props: [
    'displayed',
    'title',
    'text'
  ]
}

</script>

<style lang="scss" scoped>

  .title {
    font-size: 16px;
    text-align: center;
    font-weight: 700;
    padding-top: 20px;
    white-space: pre-line;
  }

  .text {
    text-align: center;
    white-space: pre-line;
  }

  @keyframes loader-animation {
    0% {
      width: 0;
    }
    49% {
      width: 100%;
      left: 0
    }
    50% {
      left: 200px;
    }
    100% {
      left: 0;
      width: 200px;
    }
  }
  .loader {
    margin: 30px auto;
    overflow: hidden;
    height: 5px;
    width: 200px;
  }
  .loader .bar {
    position: relative;
    height: 5px;
    background-color: #000099;
    animation-name: loader-animation;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/LoadingPopup.vue